import { ShareholderToGetAllByPersonId } from 'model/shareholder.model';
import { BaseStoreState } from 'reducer/baseStoreState';

export enum ShareholderGetAllByPersonIdActionTypes {
    SHAREHOLDER_GET_ALL_BY_PERSON_ID_REQUEST = '@@shareholder/SHAREHOLDER_GET_ALL_BY_PERSON_ID_REQUEST',
    SHAREHOLDER_GET_ALL_BY_PERSON_ID_SUCCESS = '@@shareholder/SHAREHOLDER_GET_ALL_BY_PERSON_ID_SUCCESS',
    SHAREHOLDER_GET_ALL_BY_PERSON_ID_ERROR = '@@shareholder/SHAREHOLDER_GET_ALL_BY_PERSON_ID_ERROR',
    SHAREHOLDER_GET_ALL_BY_PERSON_ID_RESET_STATE = '@@shareholder/SHAREHOLDER_GET_ALL_BY_PERSON_ID_RESET_STATE'
}

export interface ShareholderGetAllByPersonIdState extends BaseStoreState {
    readonly shareholders?: ReadonlyArray<ShareholderToGetAllByPersonId>;
}
